import * as React from "react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import {

    useLoginClientMutation,
} from "../../reducers/registerapi"; // Adjust the import path as needed
import { useAppDispatch, useAppSelector } from "../../store/index";
import { LoginClientRequest } from "../../interfaces/auth"; // Adjust the import path as needed
import {
    setCheckoutState,
    setClientId,
    setClientName,
    setToken,
} from "../../reducers/checkout";

const CheckoutUserLogin = () => {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm<LoginClientRequest>();

    const [loginClient, { isLoading, error }] = useLoginClientMutation();
    const [loginError, setLoginError] = useState("");
    const dispatch = useAppDispatch();

    const onSubmit = async (data: LoginClientRequest) => {
        try {
            const response = await loginClient(data).unwrap();
            if (response.isSuccess) {
                dispatch(setClientId(response.clientId));
                dispatch(setClientName(response.clientName ?? "Client"));
                dispatch(setToken(response.token));
                console.log("Token", response.token);
                dispatch(setCheckoutState("address"));
           } else {
                setLoginError(
                    "Login unsuccessful. Please check your credentials",
                );
            }
        } catch (err) {
            console.log("login successful!");
        }
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <h3 className="mb-3">Your Account Credentials</h3>
            {/* Display error from the login mutation */}
            {loginError && (
                <div className="alert alert-danger">
                    {loginError}
                </div>
            )}

            <div className="row mb-3">
                <label htmlFor="inputEmail" className="col-sm-3 col-form-label">
                    User name
                </label>
                <div className="col-sm-9">
                    <input
                        type="text"
                        className="form-control"
                        id="inputEmail"
                        autoComplete="username"
                        {...register("userName", {
                            required: "User name is required",
                        })}
                    />
                    {errors.userName && (
                        <span className="text-danger form-text">
                            {errors.userName.message}
                        </span>
                    )}
                    <div className="form-text">
                        Your user name is usually your email address.
                    </div>
                </div>
            </div>

            <div className="row mb-3">
                <label
                    htmlFor="inputPassword"
                    className="col-sm-3 col-form-label"
                >
                    Password
                </label>
                <div className="col-sm-9">
                    <input
                        type="password"
                        className="form-control"
                        id="inputPassword"
                        autoComplete="current-password"
                        {...register("password", {
                            required: "Password is required",
                        })}
                    />
                    {errors.password && (
                        <span className="text-danger form-text">
                            {errors.password.message}
                        </span>
                    )}
                </div>
            </div>

            <div className="row mb-3">
                <div className="col-sm-9 offset-sm-3">
                    <input
                        type="submit"
                        className="btn btn-primary"
                        value={isLoading ? "Logging in..." : "Login"}
                        disabled={isLoading}
                    />
                </div>
            </div>
        </form>
    );
};

export default CheckoutUserLogin;
